import React from 'react';
import { Target } from '../../../types/product';

interface TargetSectionProps {
  value: Target;
  onChange: (value: Target) => void;
}

// 旧 styled 定義をそのまま Tailwind クラス文字列にした定数（sections 共通の見た目）。
const SECTION = 'bg-white border border-[#e0e0e0] rounded-lg p-6 mb-6';
const SECTION_TITLE = 'm-0 mb-2 text-[18px] font-semibold text-[#333]';
const SECTION_DESCRIPTION = 'm-0 mb-6 text-[14px] text-[#666]';
const SUB_SECTION_TITLE = 'm-0 mb-4 text-[16px] font-semibold text-[#333]';
const DIVIDER = 'my-6 border-0 border-t border-t-[#e0e0e0]';
const FIELD_GROUP = 'mb-5 last:mb-0';
const LABEL = 'block mb-2 text-[14px] font-semibold text-[#333]';
const INPUT =
  'w-full px-3 py-2.5 border border-[#ddd] rounded-md text-[14px] transition-[border-color] duration-200 ease-[ease] focus:outline-none focus:border-[#4CAF50]';
const TEXTAREA =
  'w-full px-3 py-2.5 border border-[#ddd] rounded-md text-[14px] [font-family:inherit] resize-y transition-[border-color] duration-200 ease-[ease] focus:outline-none focus:border-[#4CAF50]';
const HELP_TEXT = 'm-0 mt-1.5 text-[12px] text-[#666]';

export const TargetSection: React.FC<TargetSectionProps> = ({
  value,
  onChange
}) => {
  const handleSegmentChange = (fieldValue: string) => {
    onChange({ ...value, segment: fieldValue });
  };

  const handleInsightChange = (field: string, fieldValue: string) => {
    onChange({
      ...value,
      insights: {
        ...value.insights,
        [field]: fieldValue
      }
    });
  };

  return (
    <div className={SECTION}>
      <h3 className={SECTION_TITLE}>ターゲット情報</h3>
      <p className={SECTION_DESCRIPTION}>
        ターゲット顧客のセグメントとインサイトを入力してください
      </p>

      <div className={FIELD_GROUP}>
        <label className={LABEL}>ターゲットセグメント</label>
        <input
          className={INPUT}
          type="text"
          value={value.segment || ''}
          onChange={(e) => handleSegmentChange(e.target.value)}
          placeholder="例: 30代主婦"
        />
        <p className={HELP_TEXT}>主要なターゲット顧客層</p>
      </div>

      <hr className={DIVIDER} />

      <h4 className={SUB_SECTION_TITLE}>顧客インサイト</h4>

      <div className={FIELD_GROUP}>
        <label className={LABEL}>痛み・感情</label>
        <textarea
          className={TEXTAREA}
          value={value.insights?.pain_emotion || ''}
          onChange={(e) => handleInsightChange('pain_emotion', e.target.value)}
          placeholder="例: 買い物が重い、水の品質が不安"
          rows={3}
        />
        <p className={HELP_TEXT}>顧客が抱える課題や不安</p>
      </div>

      <div className={FIELD_GROUP}>
        <label className={LABEL}>理想の状態</label>
        <textarea
          className={TEXTAREA}
          value={value.insights?.ideal_state || ''}
          onChange={(e) => handleInsightChange('ideal_state', e.target.value)}
          placeholder="例: 手間ゼロで安全な水が飲める"
          rows={3}
        />
        <p className={HELP_TEXT}>顧客が望む理想的な状態</p>
      </div>

      <div className={FIELD_GROUP}>
        <label className={LABEL}>障壁</label>
        <textarea
          className={TEXTAREA}
          value={value.insights?.barriers || ''}
          onChange={(e) => handleInsightChange('barriers', e.target.value)}
          placeholder="例: コストへの不安、解約の手間"
          rows={3}
        />
        <p className={HELP_TEXT}>購入を妨げる要因</p>
      </div>

      <div className={FIELD_GROUP}>
        <label className={LABEL}>購買決定要因</label>
        <textarea
          className={TEXTAREA}
          value={value.insights?.purchase_factor || ''}
          onChange={(e) => handleInsightChange('purchase_factor', e.target.value)}
          placeholder="例: 料金が明確、安全性の証明"
          rows={3}
        />
        <p className={HELP_TEXT}>購入の決め手となる要素</p>
      </div>
    </div>
  );
};
